import { render } from "./BiosampleMetadataColumnsDynamicRenderer.vue?vue&type=template&id=244e6474&scoped=true"
import script from "./BiosampleMetadataColumnsDynamicRenderer.vue?vue&type=script&lang=js"
export * from "./BiosampleMetadataColumnsDynamicRenderer.vue?vue&type=script&lang=js"

import "./BiosampleMetadataColumnsDynamicRenderer.vue?vue&type=style&index=0&id=244e6474&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244e6474"]])

export default __exports__